"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicModerationCopy = exports.FORUM_MODERATION_REASONS = exports.FORUM_MODERATION_OTHER_MAX = exports.FORUM_MODERATION_OTHER_MIN = exports.FORUM_MODERATION_REASON_CODES = void 0;
exports.FORUM_MODERATION_REASON_CODES = [
    'unprofessional',
    'spam',
    'confidential',
    'personal-data',
    'off-topic',
    'other',
];
exports.FORUM_MODERATION_OTHER_MIN = 5;
exports.FORUM_MODERATION_OTHER_MAX = 200;
exports.FORUM_MODERATION_REASONS = [
    {
        code: 'unprofessional',
        label: 'Unprofessional or disrespectful',
        publicCopy: 'Removed: unprofessional or disrespectful.',
    },
    {
        code: 'spam',
        label: 'Spam or solicitation',
        publicCopy: 'Removed: spam or solicitation.',
    },
    {
        code: 'confidential',
        label: 'Confidential yacht or crew information',
        publicCopy: 'Removed: confidential yacht or crew information.',
    },
    {
        code: 'personal-data',
        label: 'Personal data',
        publicCopy: 'Removed: personal data.',
    },
    {
        code: 'off-topic',
        label: 'Off-topic',
        publicCopy: 'Removed: off-topic.',
    },
    {
        code: 'other',
        label: 'Other',
        publicCopy: null,
    },
];
var publicModerationCopy = function (reasonCode, otherReason) {
    var reason = exports.FORUM_MODERATION_REASONS.find(function (item) { return item.code === reasonCode; });
    if (reason === null || reason === void 0 ? void 0 : reason.publicCopy)
        return reason.publicCopy;
    var note = otherReason === null || otherReason === void 0 ? void 0 : otherReason.trim();
    return note ? "Removed: ".concat(note) : 'This comment was removed.';
};
exports.publicModerationCopy = publicModerationCopy;
//# sourceMappingURL=forumModeration.js.map